import styled from "styled-components";
import { Box, BoxProps } from "rebass";

interface IArrowBottom extends BoxProps {
  size: number;
}

export const ArrowBottom = styled(Box)<IArrowBottom>`
  position: absolute;
  border-left: ${({ size }) => 0.866 * size}px solid transparent;
  border-right: ${({ size }) => 0.866 * size}px solid transparent;
  border-top: ${({ size }) => size}px solid #fff;
  transform: translate(50%, 0);
  box-shadow: 0 -1px 84px -20px rgba(0, 0, 0, 0.34);
`;
